import styles from './Copyright.module.css'

const Copyright = () => {
  return <div className={styles.Copyright}>Copyright © Diglot.ai 2024</div>
}

export default Copyright
